import { css } from "@emotion/react";

export const ModalNotiStyle = {
  wrapper: css`
    width: 300px !important;
    height: 185px !important;
  `,

  mainContent: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 15px;
  `,
  header: css`
    display: flex;
    flex-direction: column;
    h4 {
      font-size: 16px;
      font-weight: 500;
    }
    span {
      color: #cfcfcf;
      font-size: 12px;
      line-height: 22px;
    }
  `,
  body: css`
    display: flex;
    height: 50px;
    align-items: center;
  `,
  footer: css`
    display: flex;
    justify-content: flex-end;

    div {
      width: 83px;
      height: 34px;
      padding: 6px 12px !important;
      color: black;

      font-weight: normal;
      text-align: center;
      white-space: nowrap;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      border-radius: 4px;
    }
  `,
};
